// Lightweight fixtures for local dev and offline fallback
export const FALLBACK_TOP_MOVES: { move: string; score: number }[] = [
  { move: 'e4', score: 120 },
  { move: 'd4', score: 110 },
  { move: 'Nf3', score: 95 },
  { move: 'c4', score: 90 },
];
